import { NgModule } from '@angular/core';
import { ModalEmissionRegisterErrorComponent } from './modal-emission-register-error/modal-emission-register-error.component';
import { ModalEmissionRegisterSuccessComponent } from './modal-emission-register-success/modal-emission-register-success.component';

@NgModule({
  imports: [
    ModalEmissionRegisterSuccessComponent,
    ModalEmissionRegisterErrorComponent,
  ],
  exports: [
    ModalEmissionRegisterSuccessComponent,
    ModalEmissionRegisterErrorComponent,
  ],
})
export class EmissionRegisterModalModule {}
